// Turn var usage rule off for this file
/* eslint no-unused-vars: 0 */

// Babel imports
import 'core-js/stable'
// import 'regenerator-runtime'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// 3d Party Plugins
import Toast from 'vue-easy-toast'
import * as ModalDialogs from 'vue-modal-dialogs'

import App from './app.vue'
import router from './router'
import store from './store'

// Dashboard components
import dashboardTable from './components/dashboard/dashboard-table.vue'
import dashboardHeaderSummary from './components/dashboard/dashboard-header-summary.vue'

// Footer components
import saveTemplateBar from './components/footer/save-template-bar.vue'

// Header components
import mainHeader from './components/header/main-header.vue'
import mainHeaderLogin from './components/header/main-header-login.vue'
import headerSearch from './components/header/header-search.vue'
import dotmatrixstatus from './components/header/dotmatrixstatus.vue'
import subheaderLogin from './components/header/subheader-login.vue'

// External tracker page
import externalTracker from './components/external-tracker/external-tracker.vue'

// Report components
import reportListFilter from './components/report/list/report-list-filter.vue'
import reportListHeader from './components/report/list/report-list-header.vue'
import reportListTable from './components/report/list/report-list-table.vue'
import reportDetailTable from './components/report/detail/report-detail-table.vue'
import reportDetailHeader from './components/report/detail/report-detail-header.vue'
import reportEditColumns from './components/report/edit/report-edit-columns.vue'
import reportEditDefaultFilter from './components/report/edit/report-edit-default-filter.vue'
import reportEditGeneral from './components/report/edit/report-edit-general.vue'
import reportEditActionBar from './components/report/edit/report-edit-action-bar.vue'

// Export Proof components
import exportProofListFilter from './components/export-proof/list/export-proof-list-filter.vue'
import exportProofListHeader from './components/export-proof/list/export-proof-list-header.vue'
import exportProofListTable from './components/export-proof/list/export-proof-list-table.vue'
import exportProofDetailTable from './components/export-proof/detail/export-proof-detail-table.vue'
import exportProofDetailHeader from './components/export-proof/detail/export-proof-detail-header.vue'
import exportProofEditColumns from './components/export-proof/edit/export-proof-edit-columns.vue'
import exportProofEditDefaultFilter from './components/export-proof/edit/export-proof-edit-default-filter.vue'
import exportProofEditGeneral from './components/export-proof/edit/export-proof-edit-general.vue'
import exportProofEditActionBar from './components/export-proof/edit/export-proof-edit-action-bar.vue'

// Deadline components
import deadlineListFilter from './components/deadline/list/deadline-list-filter.vue'
import deadlineListTable from './components/deadline/list/deadline-list-table.vue'
import deadlineListHeader from './components/deadline/list/deadline-list-header.vue'
import deadlineEditDefaultFilter from './components/deadline/edit/deadline-edit-default-filter.vue'

// DailyCargo components
import dailyCargoDetailTable from './components/daily-cargo/detail/daily-cargo-detail-table.vue'
import dailyCargoTable from './components/daily-cargo/detail/daily-cargo-table.vue'
import dailyCargoDataEdit from './components/daily-cargo/edit/daily-cargo-data-edit.vue'
import dailyCargoEditActionBar from './components/daily-cargo/edit/daily-cargo-edit-action-bar.vue'
import rACNumbersModal from './components/daily-cargo/rac-validation/daily-cargo-rac-number.vue'
import dailyCargoRacValidation from './components/daily-cargo/rac-validation/daily-cargo-rac-validation.vue'
import dailyCargoDriverAdministration from './components/daily-cargo/driver-administration/daily-cargo-driver-administration.vue'
import dailyCargoFlightAdministration from './components/daily-cargo/flight-administration/daily-cargo-flight-administration.vue'
import dailyCargoIdentityCheckSheet from './components/daily-cargo/identity-check-sheet/daily-cargo-identity-check-sheet.vue'
import dailyCargoList from './sites/daily-cargo-list.vue'

// AdhocDrive components
import adhocDriveListFilter from './components/adhoc-drive/list/adhoc-drive-list-filter.vue'
import adhocDriveListHeader from './components/adhoc-drive/list/adhoc-drive-list-header.vue'
import adhocDriveListTable from './components/adhoc-drive/list/adhoc-drive-list-table.vue'
import adhocDriveEditPage from './components/adhoc-drive/edit/adhoc-drive-edit-page.vue'

// PreCarriage components
import preCarriageList from './components/precarriage/precarriage-list.vue'
import preCarriageFilter from './components/precarriage/precarriage-filter.vue'

// Linehaul Road components
import linehaulRoadListFilter from './components/linehaul-road/list/linehaul-road-list-filter.vue'
import linehaulRoadListHeader from './components/linehaul-road/list/linehaul-road-list-header.vue'
import linehaulRoadListTable from './components/linehaul-road/list/linehaul-road-list-table.vue'
import linehaulRoadEditPage from './components/linehaul-road/edit/linehaul-road-edit-page.vue'

// Parcel List components
import parcelListTable from './components/parcelList/parcel-list-table.vue'
import parcelActionBar from './components/parcelList/parcel-action-bar.vue'
import parcelListSummary from './components/parcelList/parcel-list-table-summary.vue'
import parcelUpdate from './components/parcelList/parcel-update.vue'

// Parcel Detail components
import parcelTimeline from './components/parcelDetail/parcel-timeline.vue'
import parcelDetailBlock from './components/parcelDetail/parcel-detail-block.vue'
import parcelDetailBlockAddress from './components/parcelDetail/parcel-detail-block-address.vue'
import parcelDetailBlockReferences from './components/parcelDetail/parcel-detail-block-references.vue'
import parcelDetailBlockRouting from './components/parcelDetail/parcel-detail-block-routing.vue'
import parcelDetailBlockLoadingList from './components/parcelDetail/parcel-detail-block-loading-list.vue'
import parcelDetailBlockSignedBy from './components/parcelDetail/parcel-detail-block-signed-by.vue'
import parcelDetailBlockLog from './components/parcelDetail/parcel-detail-block-log.vue'
import parcelDetailBlockScans from './components/parcelDetail/parcel-detail-block-scans.vue'
import parcelDetailBlockDocuments from './components/parcelDetail/parcel-detail-block-documents.vue'
import parcelDetailContent from './components/parcelDetail/parcel-detail-content.vue'
import problemReportListRow from './components/parcelDetail/problem-report-list-row.vue'
import problemReportFooter from './components/parcelDetail/problem-report-footer.vue'
import parcelDetailHeader from './components/parcelDetail/parcel-detail-header.vue'
import parcelDetailBlockProblemReport from './components/parcelDetail/parcel-detail-block-problem-report.vue'
import parcelMap from './components/parcelDetail/parcel-map.vue'

// Booking components
import parcelBookFooter from './components/booking/parcel-book-footer.vue'
import parcelBookSuccessModal from './components/booking/parcel-book-success-modal.vue'
import bookingGeneralInformation from './components/booking/booking-general-information.vue'
import bookingParcelCounterNumber from './components/booking/parcel-counter-number.vue'
import bookingConsolidatedContainerDetails from './components/booking/consolidated-container-details.vue'
import bookingAdditionalReferences from './components/booking/booking-additional-references.vue'
import bookingAddress from './components/booking/booking-address.vue'
import bookingAdditionalInformation from './components/booking/booking-additional-informations.vue'
import bookingParcelDetails from './components/booking/booking-parcel-details.vue'
import returnParcelSelectModal from './components/booking/return-parcel-select-modal.vue'

// Admin
import userListFilter from './admin/user-list-filter.vue'
import updateInternalNews from './admin/update-internal-news.vue'

// Address components
import editCreateAddressModal from './components/address/edit-create-address-modal.vue'

// Monitor Components
import itemMigrationErrorList from './components/monitor/item-migration-error-list.vue'

// Form components
import formInput from './components/form/form-input.vue'
import formDatepicker from './components/form/form-datepicker.vue'
import formTextarea from './components/form/form-textarea.vue'
import formLabel from './components/form/form-label.vue'
import formButton from './components/form/form-button.vue'
import formSelect from './components/form/form-select.vue'
import formFilteredMultiselect from './components/form/form-filtered-multiselect.vue'
import formFilteredSelect from './components/form/form-filtered-select.vue'
import formRadiobuttonGroup from './components/form/form-radiobutton-group.vue'
import formCheckbox from './components/form/form-checkbox.vue'
import formToggleSwitch from './components/form/form-toggle-switch.vue'

// Shared components
import countrySelect from './components/shared/country-select.vue'
import countryMultiselect from './components/shared/country-multiselect.vue'
import customerSelect from './components/shared/customer-select.vue'
import customerMultiselect from './components/shared/customer-multiselect.vue'
import providerMultiselect from './components/shared/provider-multiselect.vue'
import barcodeScanner from './components/shared/barcode-scanner.vue'
import tagMultiselect from './components/shared/tag-multiselect.vue'
import scanParcelsModal from './components/shared/scan-parcels-modal.vue'
import subpageHeader from './components/shared/subpage-header.vue'
import createProblemReportModal from './components/shared/create-problem-report-modal.vue'
import listControls from './components/shared/list-controls.vue'
import fileUploadModal from './components/shared/file-upload-modal.vue'
import deactivateEventModal from './components/shared/deactivate-event-modal.vue'
import deleteParcelModal from './components/shared/delete-parcel-modal.vue'
import reactivateParcelModal from './components/shared/reactivate-parcel-modal.vue'
import createCMRModal from './components/shared/create-cmr-modal.vue'
import contactComponent from './components/shared/contact-component.vue'
import generalFooter from './components/shared/general-footer.vue'
import parcelFilter from './components/shared/parcel-filter.vue'
import serviceLevelMultiselect from './components/shared/service-level-multiselect.vue'
import serviceLevelSelect from './components/shared/service-level-select.vue'
import providerSelect from './components/shared/provider-select.vue'
import currencySelect from './components/shared/currency-select.vue'
import flightSelect from './components/shared/flight-select.vue'
import selectedServiceLeg from './components/shared/service-leg-select.vue'
import vehicleSelect from './components/shared/vehicle-select.vue'
import preCarriageRouteMultiselect from './components/shared/precarriage-route-multiselect.vue'
import linehaulRoadSelect from './components/shared/linehaulroad-select.vue'

// System message components
import messageModal from './components/system_messages/message-modal.vue'

// Login components
import recoverPasswordModal from './components/login/recover-password-modal.vue'

// Pudo components
import pudoExpiryActionModal from './components/pudo/pudo-expiry-action-modal.vue'
import pudoFilter from './components/pudo/pudo-filter.vue'

// Match Scan
import matchScanHeader from './components/match-scan/match-scan-header.vue'

// Problem Report Measures Components
import measuresFilter from './components/measures/measures-filter.vue'
import addMeasureModal from './components/measures/add-measure-modal.vue'

// Anonymous Tracking

import Draggable from 'vuedraggable'

// Tabs
import { Tabs, Tab } from 'vue-tabs-component'

// Permission check plugin
import Permssions from './plugins/permission'

// Media Query plugin for mobile optimization
import VueMq from 'vue-mq'

// Datepicker for mobile environment
import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

import moment from 'moment'

// masked input for datetime
import VueTheMask from 'vue-the-mask'

// Validation Framework
import Vuelidate from 'vuelidate'

import vuetify from './plugins/vuetify'

Vue.use(Vuelidate)

Vue.use(VueTheMask)

Vue.use(Datetime)

// Permission Check Plugin
Vue.use(Permssions)

// Tabs
Vue.component('Tabs', Tabs)
Vue.component('Tab', Tab)

// draggable for report / column setup
Vue.use(Draggable as any)

// Toast message plugin
Vue.use(<any>Toast)

// Dialog Plugin
Vue.use(<any>ModalDialogs)

Vue.use(VueMq, {
  breakpoints: {
    sm: 600,
    lg: Infinity
  }
})

// Dashboard components
Vue.component('DashboardTable', dashboardTable)

// Footer components
Vue.component('SaveTemplateBar', saveTemplateBar)

// Header components
Vue.component('MainHeader', mainHeader)
Vue.component('MainHeaderLogin', mainHeaderLogin)
Vue.component('HeaderSearch', headerSearch)
Vue.component('Dotmatrixstatus', dotmatrixstatus)
Vue.component('DashboardHeaderSummary', dashboardHeaderSummary)
Vue.component('SubheaderLogin', subheaderLogin)

// External tracker page
Vue.component('ExternalTracker', externalTracker)

// Report components
Vue.component('ReportListFilter', reportListFilter)
Vue.component('ReportListHeader', reportListHeader)
Vue.component('ReportListTable', reportListTable)
Vue.component('ReportDetailTable', reportDetailTable)
Vue.component('ReportDetailHeader', reportDetailHeader)
Vue.component('ReportEditColumns', reportEditColumns)
Vue.component('ReportEditDefaultFilter', reportEditDefaultFilter)
Vue.component('ReportEditGeneral', reportEditGeneral)
Vue.component('ReportEditActionBar', reportEditActionBar)

// Export Proof components
Vue.component('ExportProofListFilter', exportProofListFilter)
Vue.component('ExportProofListHeader', exportProofListHeader)
Vue.component('ExportProofListTable', exportProofListTable)
Vue.component('ExportProofDetailTable', exportProofDetailTable)
Vue.component('ExportProofDetailHeader', exportProofDetailHeader)
Vue.component('ExportProofEditColumns', exportProofEditColumns)
Vue.component('ExportProofEditDefaultFilter', exportProofEditDefaultFilter)
Vue.component('ExportProofEditGeneral', exportProofEditGeneral)
Vue.component('ExportProofEditActionBar', exportProofEditActionBar)

// Deadline components
Vue.component('DeadlineListFilter', deadlineListFilter)
Vue.component('DeadlineListTable', deadlineListTable)
Vue.component('DeadlineListHeader', deadlineListHeader)
Vue.component('DeadlineEditDefaultFilter', deadlineEditDefaultFilter)

// AdhocDrive components
Vue.component('AdhocDriveListFilter', adhocDriveListFilter)
Vue.component('AdhocDriveListHeader', adhocDriveListHeader)
Vue.component('AdhocDriveListTable', adhocDriveListTable)
Vue.component('AdhocDriveEditPage', adhocDriveEditPage)

// Linehaul Road components
Vue.component('LinehaulRoadListFilter', linehaulRoadListFilter)
Vue.component('LinehaulRoadListHeader', linehaulRoadListHeader)
Vue.component('LinehaulRoadListTable', linehaulRoadListTable)
Vue.component('LinehaulRoadEditPage', linehaulRoadEditPage)

// DailyCargo components
Vue.component('DailyCargoDetailTable', dailyCargoDetailTable)
Vue.component('DailyCargoTable', dailyCargoTable)
Vue.component('DailyCargoDataEdit', dailyCargoDataEdit)
Vue.component('DailyCargoEditActionBar', dailyCargoEditActionBar)
Vue.component('DailyCargoRacNumber', rACNumbersModal)
Vue.component('DailyCargoRacValidation', dailyCargoRacValidation)
Vue.component('DailyCargoDriverAdministration', dailyCargoDriverAdministration)
Vue.component('DailyCargoFlightAdministration', dailyCargoFlightAdministration)
Vue.component('DailyCargoIdentityCheckSheet', dailyCargoIdentityCheckSheet)
Vue.component('DailyCargoList', dailyCargoList)

// PreCarriage components
Vue.component('PrecarriageFilter', preCarriageFilter)
Vue.component('PrecarriageList', preCarriageList)

// Parcel components
Vue.component('ListControls', listControls)
Vue.component('ProblemReportListRow', problemReportListRow)
Vue.component('ProblemReportFooter', problemReportFooter)
Vue.component('ParcelDetailHeader', parcelDetailHeader)
Vue.component('SubpageHeader', subpageHeader)
Vue.component('ParcelBookFooter', parcelBookFooter)
Vue.component('ParcelBookSuccessModal', parcelBookSuccessModal)
Vue.component('BookingGeneralInformation', bookingGeneralInformation)
Vue.component('ParcelCounterNumber', bookingParcelCounterNumber)
Vue.component('ConsolidatedContainerDetails', bookingConsolidatedContainerDetails)
Vue.component('BookingAdditionalReferences', bookingAdditionalReferences)
Vue.component('BookingAddress', bookingAddress)
Vue.component('BookingAdditionalInformations', bookingAdditionalInformation)
Vue.component('BookingParcelDetails', bookingParcelDetails)
Vue.component('ParcelTimeline', parcelTimeline)
Vue.component('ParcelDetailBlock', parcelDetailBlock)
Vue.component('ParcelDetailBlockAddress', parcelDetailBlockAddress)
Vue.component('ParcelDetailBlockReferences', parcelDetailBlockReferences)
Vue.component('ParcelDetailBlockRouting', parcelDetailBlockRouting)
Vue.component('ParcelDetailBlockLoadingList', parcelDetailBlockLoadingList)
Vue.component('ParcelDetailBlockSignedBy', parcelDetailBlockSignedBy)
Vue.component('ParcelDetailBlockLog', parcelDetailBlockLog)
Vue.component('ParcelDetailBlockScans', parcelDetailBlockScans)
Vue.component('ParcelDetailBlockDocuments', parcelDetailBlockDocuments)
Vue.component('ParcelDetailContent', parcelDetailContent)
Vue.component('ParcelActionBar', parcelActionBar)
Vue.component('ReturnParcelSelectModal', returnParcelSelectModal)
Vue.component('ParcelListTable', parcelListTable)
Vue.component('ParcelListTableSummary', parcelListSummary)
Vue.component('ScanParcelsModal', scanParcelsModal)
Vue.component('CreateProblemReportModal', createProblemReportModal)
Vue.component('ParcelDetailBlockProblemReport', parcelDetailBlockProblemReport)
Vue.component('ParcelMap', parcelMap)

// Admin
Vue.component('UserListFilter', userListFilter)
Vue.component('UpdateInternalNews', updateInternalNews)

// Match Scan
Vue.component('MatchScanHeader', matchScanHeader)

// Shared components
Vue.component('DeleteParcelModal', deleteParcelModal)
Vue.component('ReactivateParcelModal', reactivateParcelModal)
Vue.component('CreateCmrModal', createCMRModal)
Vue.component('FileUploadModal', fileUploadModal)
Vue.component('DeactivateEventModal', deactivateEventModal)
Vue.component('ContactComponent', contactComponent)
Vue.component('GeneralFooter', generalFooter)
Vue.component('ParcelFilter', parcelFilter)

// Parcel Update Components
Vue.component('ParcelUpdate', parcelUpdate)

// Address components
Vue.component('EditCreateAddressModal', editCreateAddressModal)

// Monitor Components
Vue.component('ItemMigrationErrorList', itemMigrationErrorList)

// General Selection Components
Vue.component('CountrySelect', countrySelect)
Vue.component('CountryMultiselect', countryMultiselect)
Vue.component('CustomerSelect', customerSelect)
Vue.component('CustomerMultiselect', customerMultiselect)
Vue.component('ProviderMultiselect', providerMultiselect)
Vue.component('TagMultiselect', tagMultiselect)
Vue.component('ServiceLevelMultiselect', serviceLevelMultiselect)
Vue.component('ServiceLevelSelect', serviceLevelSelect)
Vue.component('ProviderSelect', providerSelect)
Vue.component('CurrencySelect', currencySelect)
Vue.component('FlightSelect', flightSelect)
Vue.component('ServiceLegSelect', selectedServiceLeg)
Vue.component('VehicleSelect', vehicleSelect)
Vue.component('PrecarriageRouteMultiselect', preCarriageRouteMultiselect)
Vue.component('LinehaulroadSelect', linehaulRoadSelect)
Vue.component('BarcodeScanner', barcodeScanner)

// Form components
Vue.component('FormInput', formInput)
Vue.component('FormDatepicker', formDatepicker)
Vue.component('FormTextarea', formTextarea)
Vue.component('FormLabel', formLabel)
Vue.component('FormButton', formButton)
Vue.component('FormSelect', formSelect)
Vue.component('FormFilteredMultiselect', formFilteredMultiselect)
Vue.component('FormFilteredSelect', formFilteredSelect)
Vue.component('FormRadiobuttonGroup', formRadiobuttonGroup)
Vue.component('FormCheckbox', formCheckbox)
Vue.component('FormToggleSwitch', formToggleSwitch)

// System message components
Vue.component('MessageModal', messageModal)

// Login components
Vue.component('RecoverPasswordModal', recoverPasswordModal)

// Pudo components
Vue.component('PudoExpiryActionModal', pudoExpiryActionModal)
Vue.component('PudoFilter', pudoFilter)

// Problem Report Measures Components
Vue.component('MeasuresFilter', measuresFilter)
Vue.component('AddMeasureModal', addMeasureModal)

// Anonymous Tracking Components

Vue.config.productionTip = false
declare global {
  interface Window {
    app: Vue
    bus: Vue,
    appReady: boolean
  }
}

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD')
  }
})

// Global event listener
window.bus = new Vue()

window.appReady = false

router.beforeEach((to, from, next) => {
  store.dispatch('auth/initialize')
  // console.warn('beforeEach > \nto: ', to, '\nfrom:', from, '\nisAuthenticated:', store.getters['auth/isAuthenticated'])
  if (!store.getters['auth/isAuthenticated']()) {
    if (to.path !== '/login' && to.path !== '/verify-user' && to.path !== '/tracking') {
      next('/login?forwardPath=' + encodeURI(to.fullPath))
    } else {
      next()
    }
  } else {
    if (to.path === '/login') {
      next('/dashboard')
    } else {
      store.dispatch('init').then(() => {
        next()
      }).catch(() => {
        window.bus.$emit('openErrorModal', 'Error loading necessary data please reload page')
      })
    }
  }
})

/* eslint-disable no-new */
var localApp: Vue = new Vue({
  store,
  router,
  components: { App },
  vuetify,
  template: '<App/>'
}).$mount('#app')

window.app = localApp
